<markdown lineNumbers [data]="readMeData"></markdown>
